import React, { useEffect, useState } from 'react';
import UserContext from './UserContext';
import { auth } from './firebase';
import { GoogleAuthProvider, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'

const UserProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [userDetails,setUserDetails] = useState(null);
  const [changes,setChanges] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthenticated(true);
        setUserInfo(user);
      } else {
        setAuthenticated(false);
        setUserInfo(null);
        setError(null)
      }
    });

    return () => unsubscribe();
  }, []);


  useEffect(()=> {
    console.log('Authenticated:',authenticated)
  },[authenticated])


  const checkTokenExpiration = async () => {
    const expirationTime = localStorage.getItem("expirationTime");
    const currentTime = Date.now();
  

    if (currentTime >= expirationTime) {
      await signOut(auth);
      setAuthenticated(false);
      setUserInfo(null);
      localStorage.removeItem("expirationTime");
      alert("Your session has expired. Please log in again.");
      navigate('/login');
    } else {
      const timeRemaining = expirationTime - currentTime;
      setTimeout(checkTokenExpiration, timeRemaining);
    }
  }

  const getUserDetails = async (id) => {
    try {
      const resp = await axios.get(
        `https://event-finder12.onrender.com/users/getuser/${id}`
      )
      setUserDetails(resp.data);
      return resp.data;
    } catch (err) {
      console.log(err);
    }
  }



  const signIn = async (userData) => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        userData.email,
        userData.password
      );

      if (userCredential) {
        const user = userCredential.user;
        const expiresIn = 60 * 25 * 1000;
        const expirationTime = Date.now() + expiresIn;
        localStorage.setItem("expirationTime", expirationTime);
        setUserInfo(user);
        setAuthenticated(true);
        getUserDetails(userData.email)
        checkTokenExpiration();
        console.log(userInfo)
      }
    } catch (err) {
      setError(err);
      console.log(err);
    }
  };




  const SignInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth,provider)
    .then(async (res) => {
        const credential = GoogleAuthProvider.credentialFromResult(res);
        const token = credential.accessToken;
        const user = res.user;
        setUserInfo(user);
        const expiresIn = 60 * 25 * 1000;
        const expirationTime = Date.now() + expiresIn;
        localStorage.setItem("expirationTime", expirationTime);
        checkTokenExpiration();
        const body = {
            displayName: user.displayName,
            email: user.email,
            role: 'customer'
          }
          const response = await axios.post('https://event-finder12.onrender.com/users/createuser', body);
          getUserDetails(user.email)
    }).catch((err)=> {
        console.log(err);
    })
  }

  const logout = async () => {
    try {
      await signOut(auth);
      setAuthenticated(false);
      setUserInfo(null);
      navigate('/login');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <UserContext.Provider value={{ authenticated, userInfo, signIn, logout,setChanges,changes, error,SignInWithGoogle,setError,userDetails,setUserDetails,getUserDetails }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
